import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuotationService {

  url = environment.url;
  
  constructor(
    private http: HttpClient
  ) { }
  

  pending_quotation(data){
    return this.http.post(`${this.url}/pending_quotation`,data);
  }

  approval(attachment, id){
    return this.http.post(`${this.url}/approval/`+id, attachment);
  }

  view_quotation(id){
    return this.http.get(`${this.url}/view_quotation/` +id);
  }

  // view_quotation1(id){
  //   return this.http.get(`${this.url}/view_quotation/` +id).toPromise();
  // }

  getBenefitRates(){
    return this.http.get(`${this.url}/policyIssue/getBenefitRates`);
    
  }

  getPaymentList(){
    return this.http.get(`${this.url}/policyIssue/getPaymentList`);
    
  }

  cancelQuote(quoteId,remarks){
    return this.http.get(`${this.url}/policyIssue/cancelQuote?remarks=`+remarks+'&quotId='+quoteId);
  }


  pendingQuote(data){
    return this.http.post(`${this.url}/policyIssue/pendingQuote`, data);
  }


  syncCommissionPremiumByLoginType(loginId, productId) {
		return this.http.get(`${this.url}/policyIssue/getCommPremByLoginType?loginId=`+loginId+'&productId='+productId);
	}

  download(file_url){
		// return this.http.get(`${this.url}/download/` + id);

     let data = {
      url: file_url
    }


    return this.http.post(this.url + '/get_file', { data }, {
      responseType: 'text' 
    });
    // return this.http.post(this.url + '/get_file', { data });
  }


  quotationPDF(quoteId){
    const httpOptions = {
      responseType: ('blob' as 'json')
    };
    
		return this.http.get(`${this.url}/quotationPDF/`+quoteId, httpOptions);
  }

  changeStatusToPending(quoteId){
		return this.http.get(`${this.url}/changeStatusToPending/`+quoteId);
    
  }



}
